import React, { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import ResponsibleForm from "../../ComponentsV2/NewCart/responsible/ResponsibleForm";

import { AppContext } from "../../context";
import { Radio } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  responsible: {},
  divider: {
    marginBottom: "16px",
  },
  title: {},
  subtitle: {
    fontSize: "0.875rem",
    marginBottom: "0.5rem",
    fontWeight: "400",
    lineHeight: "1.75",
  },
  label: {
    marginRight: 0,
    marginLeft: "-6px",
  },
  labelText: {
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  radio: {
    padding: "6px",
  },
  group: {
    marginBottom: "16px",
  },
  giftCertificateButton: {
    marginTop: "1rem",
  },
}));

const Responsible = (props) => {
  const {
    authenticated,
    hasFee,
    newId,
    responsible,
    selected,
    setSelected,
    ticketOwners,
    selectedDeliveryMethod,
    providesResponsible,
    isGiftCertificate,
    submitNoToggleTerms,
  } = props;
  const { classes } = useStyles();
  const { config, language } = useSelector((state) => ({
    config: state.config,
    language: state.language,
  }));

  const { state } = useContext(AppContext);

  useEffect(() => {
    if (authenticated || !providesResponsible) {
      return setSelected(undefined);
    }
    if (!selected && responsible && responsible.id) {
      setSelected(`${responsible.id}`);
    }
  }, [selected, authenticated, responsible, setSelected, providesResponsible]);

  useEffect(() => {
    if (isGiftCertificate && state?.giftCertificate?.coverTotalCost === false) {
      submitNoToggleTerms();
    }
  }, [state.giftCertificate]);

  if (!providesResponsible) return null;

  return (
    <div className={classes.responsible}>
      {authenticated && (
        <h6 className={`${classes.subtitle} secondary-text`}>
          {language.Logged_In}
        </h6>
      )}
      {ticketOwners && ticketOwners.length > 0 && (
        <div className={classes.customerSelect}>
          <Radio.Group
            aria-label="Resposible"
            className={classes.group}
            value={`${selected}`}
            onChange={setSelected}
            name={language.Step_Responsible_Sub}
            label={language.Step_Responsible_Sub}
            labelProps={{ className: classes.subtitle }} // change to classNames (label) in v7
          >
            {ticketOwners.map((o) => (
              <Radio
                value={o.id}
                label={`${o.firstName} ${o.lastName}`}
                key={o.id}
                className={classes.radio}
                style={{ color: "black" }}
              />
            ))}
            <Radio
              value={newId}
              className={classes.radio}
              classes={{ label: classes.labelText }}
              label={language.Responsible_Other}
            />
          </Radio.Group>
        </div>
      )}
      <ResponsibleForm
        hasFee={hasFee}
        authenticated={authenticated}
        selectedDeliveryMethod={selectedDeliveryMethod}
      />
    </div>
  );
};

export default Responsible;
